import { CodeFieldIncludeInactiveKey } from 'app/area/indicator-factors/types-store';

export const defaultMaxResults = 50;
export const defaultIncludeInactiveCodes = CodeFieldIncludeInactiveKey.active;
